module.exports = __webpack_public_path__ + "static/media/socialStatistics.c4f9e5a8.svg";